import { createRoot } from 'react-dom/client'
import { lazy, Suspense, type ReactNode } from 'react';
import { LazyMotion, domAnimation } from 'motion/react';
import './index.css'
import App from './App.tsx'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext.tsx';
import Layouts from './components/layouts.tsx';

import ScrollToTop from './components/ScrollToTop.tsx';
import DeferredToaster from './components/DeferredToaster.tsx';

const ProductPage = lazy(() => import('./pages/ProductPage'));
const ProductInfoPage = lazy(() => import('./pages/ProductInfoPage'));
const DiscordCallback = lazy(() => import('./pages/DiscordCallback.tsx'));
const MyResourcePage = lazy(() => import('./pages/MyResourcePage.tsx'));
const AddFundsPage = lazy(() => import('./pages/AddFundsPage.tsx'));
const PolicyPage = lazy(() => import('./pages/PolicyPage.tsx'));
const TosPage = lazy(() => import('./pages/ToSPage.tsx'));

const AdminLayouts = lazy(() => import('./components/admin/layouts.tsx'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard.tsx'));
const AdminPackagesPage = lazy(() => import('./pages/admin/AdminPackagesPage.tsx'));
const AdminMembersPage = lazy(() => import('./pages/admin/AdminMembersPage.tsx'));
const AdminReportPage = lazy(() => import('./pages/admin/AdminReportPage.tsx'));
const AdminCategoriesPage = lazy(() => import('./pages/admin/AdminCategoriesPage.tsx'));
const AdminProductEditorPage = lazy(() => import('./pages/admin/AdminProductEditorPage.tsx'));

const routeFallback = (
	<div className="flex min-h-[40vh] items-center justify-center" role="status" aria-live="polite">
		<span className="size-8 animate-spin rounded-full border-2 border-white/15 border-t-white motion-reduce:animate-none" />
		<span className="sr-only">กำลังโหลดหน้า</span>
	</div>
);

const loadRoute = (route: ReactNode) => (
	<Suspense fallback={routeFallback}>{route}</Suspense>
);

	createRoot(document.getElementById('root')!).render(
			<>
				<LazyMotion features={domAnimation}>
					<BrowserRouter>
						<UserProvider>
							<DeferredToaster />
							<ScrollToTop />
							<Routes>
					<Route path="/" element={<Layouts />}>
						<Route index element={<App />} />
						<Route path="/product" element={loadRoute(<ProductPage />)} />
						<Route path="/product/:id" element={loadRoute(<ProductInfoPage />)} />
						<Route path="/add-funds" element={loadRoute(<AddFundsPage />)} />
						<Route path="/resource" element={loadRoute(<MyResourcePage />)} />
						<Route path="/policy" element={loadRoute(<PolicyPage />)} />
						<Route path="/tos" element={loadRoute(<TosPage />)} />
						<Route path="/auth/callback/discord" element={loadRoute(<DiscordCallback />)} />
					</Route>

					<Route path="/admin" element={loadRoute(<AdminLayouts />)}>
						<Route index element={loadRoute(<AdminDashboard />)} />
						<Route path="members" element={loadRoute(<AdminMembersPage />)} />
						<Route path="packages" element={loadRoute(<AdminPackagesPage />)} />
						<Route path="packages/new" element={loadRoute(<AdminProductEditorPage />)} />
						<Route path="packages/:id/edit" element={loadRoute(<AdminProductEditorPage />)} />
							<Route path="category" element={loadRoute(<AdminCategoriesPage />)} />
							<Route path="report" element={loadRoute(<AdminReportPage />)} />
						</Route>
							</Routes>
						</UserProvider>
					</BrowserRouter>
				</LazyMotion>
		</>
	)
